
import { Vue, Component } from 'vue-property-decorator';
import Labels from '@/features/shipment/components/shipmentSuccess/instructions/Labels.vue';
import Package from '@/features/shipment/components/shipmentSuccess/instructions/Package.vue';
import Insurance from '@/features/shipment/components/shipmentSuccess/instructions/Insurance.vue';
import { acknowledgeShipForSuccess } from '@/features/shipment/services/shipment.services';

@Component({
  components: {
    Labels,
    Package,
    Insurance,
  },
})
export default class Instructions extends Vue {
  private step = 0;

  private handleBack(): void {
    if (this.step === 0) {
      this.$router.go(-1);
    } else {
      this.step -= 1;
    }
  }

  private async handleNext(): Promise<void> {
    if (this.step < 2) {
      this.step += 1;
    } else {
      await this.submit();
    }
  }

  private async submit(): Promise<void> {
    const { redirectTo } = this.$route.query;

    if (this.$store.getters.getShowSuccessShip) {
      const customData = { event: 'create-shipment-visit', is_first_visit: true };

      if (this.$gtm?.enabled() && window.dataLayer !== undefined) {
        window.dataLayer.push(customData);
      }
    }

    this.$store.commit('setShowSuccessShip', false);
    await acknowledgeShipForSuccess();
    this.$router.replace(redirectTo as string || { name: 'shipment-create' });
  }
}
